import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { LayoutDashboard, LogOut } from 'lucide-react';
import { MARKETING_HOME_URL } from '../constants/externalLinks';
import { LEGAL_UPDATED_AT, termsIntro, termsSections } from '../constants/legalDocuments';
import LegalSectionContent from './legal/LegalSectionContent';

const TermsOfService = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const AuthNavButton = ({ isMobile = false }) => {
    if (isAuthenticated) {
      return (
        <div className="flex items-center gap-4">
          <Link
            to="/painel"
            className={`flex items-center gap-2 font-medium transition-colors ${
              isMobile
                ? 'bg-[#2B5A41] text-white px-4 py-2 rounded-full text-sm'
                : 'text-[#203C2E] hover:text-[#2B5A41]'
            }`}
          >
            <LayoutDashboard className="h-4 w-4" />
            Painel
          </Link>
          <button
            onClick={handleLogout}
            title="Sair"
            className={`flex items-center justify-center p-2 rounded-full transition-colors ${
              isMobile
                ? 'bg-red-500 text-white hover:bg-red-600'
                : 'bg-red-100 text-red-600 hover:bg-red-200'
            }`}
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      );
    }

    return (
      <Link
        to="/login"
        className={`bg-[#2B5A41] text-white rounded-full hover:bg-[#203C2E] transition-colors font-medium ${
          isMobile ? 'px-4 py-2 text-sm' : 'px-6 py-2'
        }`}
      >
        Entrar
      </Link>
    );
  };

  return (
    <div className="min-h-screen bg-[#F5F6F0]">
      <header className="fixed top-0 left-0 right-0 bg-[#F5F6F0]/95 backdrop-blur-md border-b border-[#E0EDE3] z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href={MARKETING_HOME_URL}>
                <img src="/assets/logo.png" alt="Constela Brasil" className="h-10 w-auto" />
              </a>
            </div>

            <nav className="hidden md:flex items-center space-x-8">
              <Link
                to="/terapeutas"
                className="text-[#203C2E] hover:text-[#2B5A41] font-medium transition-colors"
              >
                Home
              </Link>
              <Link to="/planos" className="text-[#203C2E] hover:text-[#2B5A41] font-medium transition-colors">
                Planos
              </Link>
              <AuthNavButton />
            </nav>

            <div className="md:hidden">
              <AuthNavButton isMobile={true} />
            </div>
          </div>
        </div>
      </header>

      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold text-[#2B5A41] mb-4">{termsIntro.title}</h1>
            <p className="text-xl text-[#5F7167] max-w-3xl mx-auto">{termsIntro.subtitle}</p>
            <p className="text-sm text-[#5F7167] mt-4">Última atualização: {LEGAL_UPDATED_AT}</p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {termsIntro.paragraphs.map((paragraph) => (
                <p key={paragraph} className="text-[#5F7167] mb-4">
                  {paragraph}
                </p>
              ))}

              <LegalSectionContent sections={termsSections} />

              <div className="text-center pt-8 border-t border-[#E0EDE3]">
                <p className="text-sm text-[#5F7167] mb-2">
                  Estes Termos complementam a nossa{' '}
                  <Link to="/politica-de-privacidade" className="text-[#89A78C] hover:underline">
                    Política de Privacidade
                  </Link>
                  .
                </p>
                <p className="text-xs text-[#5F7167]">
                  Ao continuar a utilizar os nossos serviços, você concorda com estes termos na versão mais recente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
